//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import HiHeader from "../../components/header/Index.vue";
import HiCell from "../../components/cell/Index";
import HiButton from "../../components/button/Index.vue";
import InstagramUserItem from "../../components/plan/instagram_user_item/Index.vue";
import { mapGetters } from "vuex";
import { CURRENT_USER_INFO_SIMPLE } from "../../store/mutation-types";
import { mulModifyUnlimited } from "../../services/users";
import { showErrorMsg } from "../../utils/error";
import MulConfirm from "../../components/confirm/Mul";
// import {dateFormat} from '../../utils/plugin_helper'22
export default {
  name: "ModifyAutoPostPage",
  components: { HiHeader, HiButton, InstagramUserItem, HiCell, MulConfirm },
  data() {
    const _this = this;
    return {
      selectIds: [],
      oldSelectIds: [],
      title: _this.$t("addUnlimitedAccountPage.freeUserType"),
      showLockMenu: false,
      lockText: "",
      buttons: [
        {
          text: _this.$t("common.upgrade"),
          async click() {
            _this.$router.push({
              name: "PaymentUpgradePage",
              params: { type: "filter" },
            });
            return true;
          },
        },
        {
          text: _this.$t("common.contactUs"),
          async click() {
            window.open(process.env.CONTACT_US, "_blank");
            return true;
          },
        },
      ],
    };
  },
  methods: {
    /**
     * 计算当前项类型 (是否可选中)
     */
    itemType(item) {
      if (item.socialNetwork === 1) {
        // ins账号
        return this.allowAddInsNum > 0 || item.wasPremium
          ? "select"
          : "unselect";
      } else if (item.socialNetwork === 2 || item.socialNetwork === 3) {
        // fb账号
        return this.allowAddFbNum > 0 || item.wasPremium
          ? "select"
          : "unselect";
      } else if (item.socialNetwork === 4) {
        // fb账号
        return this.allowAddTwNum > 0 || item.wasPremium
          ? "select"
          : "unselect";
      }
    },
    /**
     * 单条记录点击事件
     */
    async itemClick(item) {
      const selectType = this.itemType(item);
      // 判断当前是否为老账号
      if (item.wasPremium) {
        // 查看以选中项中是否包含点击项
        const index = this.oldSelectIds.findIndex((id) => {
          return item.id === id;
        });
        // 如果不存在，则添加当前点击项到数组中
        if (index === -1) {
          this.oldSelectIds.push(item.id);
        } else {
          // 否则删除该项
          this.oldSelectIds.splice(index, 1);
        }
        return;
      }
      // 查看以选中项中是否包含点击项
      const index = this.selectIds.findIndex((id) => {
        return item.id === id;
      });
      // 如果不存在，则添加当前点击项到数组中
      if (index === -1) {
        this.selectIds.push(item.id);
      } else {
        // 否则删除该项
        this.selectIds.splice(index, 1);
      }
      if (selectType !== "select" && !item.select) {
        // 还原最后一项
        this.selectIds.splice(this.selectIds.length - 1, 1);
        // 并彈出升級提示
        // 获取国际化升级按钮和文案
        const upgradeBtnText = this.$t("common.upgrade");
        let upgradeText = this.$t("addUnlimitedAccountPage.upgradeText", {
          number: this.user.plan.premiumInstagramPublisherCount,
        });
        // fb特殊提示
        if (item.socialNetwork === 2 || item.socialNetwork === 3) {
          upgradeText = `Support ${this.user.plan.premiumFacebookPublisherCount} Facebook. Upgrade your plan to get more.`;
        }
        if (item.socialNetwork === 4) {
          upgradeText = `Support ${this.user.plan.premiumFacebookPublisherCount} Twitter. Upgrade your plan to get more.`;
        }
        await this.$confirm.show({
          text: upgradeText,
          yesText: upgradeBtnText,
        });
        this.$router.push({
          name: "PaymentUpgradePage",
          params: { type: "filter" },
        });
      }
      // // 如果新账号无可选 且有老账号可选，提示30天
      // let show30Modal = false
      // // 只检查未选中变成选中 并且是新账号
      // if (!item.select) {
      // // 选中的是ins账号则判断
      //   if (item.socialNetwork === 1) {
      //     // 判断可选的新账号是否已选满
      //     const publishers = this.user.linkedInstagramList.filter(l => (l.isUnlimited || (!l.isUnlimited && l.wasPremium)) && !l.isMember && l.status !== 2 && l.socialNetwork === 1)
      //     const canAddNewNum = this.user.plan.premiumInstagramPublisherCount - publishers.length
      //     if (canAddNewNum === 0) {
      //       show30Modal = true
      //     }
      //   } else {
      //     // facebook
      //     // 判断可选的新账号是否已选满
      //     const publishers = this.user.linkedInstagramList.filter(l => (l.isUnlimited || (!l.isUnlimited && l.wasPremium)) && !l.isMember && l.status !== 2 && l.socialNetwork !== 1)
      //     const canAddNewNum = this.user.plan.premiumFacebookPublisherCount - publishers.length
      //     if (canAddNewNum === 0) {
      //       show30Modal = true
      //     }
      //   }
      // }
      // if (show30Modal) {
      //   // 还原最后一项
      //   this.selectIds.splice(this.selectIds.length - 1, 1)
      //   // 弹出30天提示
      //   // 获取国际化30天升级提示
      //   const date = dateFormat({ date: this.user.plan.nextLimitTime, format: 'MMMM D, YYYY' })
      //   const dayLimitedText = this.$t('addUnlimitedAccountPage.dayLimitedText', {
      //     date: date
      //   })
      //   this.lockText = dayLimitedText
      //   this.showLockMenu = true
      // }
      // // 如果新账号无可选 且有老账号可选，提示30天
      // if (this.allowAddNewNum < 0 && !oldFull) {
      //   // 还原最后一项
      //   this.selectIds.splice(this.selectIds.length - 1, 1)
      //   // 弹出30天提示
      //   // 获取国际化30天升级提示
      //   const date = dateFormat({ date: this.user.plan.nextLimitTime, format: 'MMMM D, YYYY' })
      //   const dayLimitedText = this.$t('addUnlimitedAccountPage.dayLimitedText', {
      //     date: date
      //   })
      //   this.lockText = dayLimitedText
      //   this.showLockMenu = true
      // }
    },
    /**
     * select按钮点击事件
     */
    async saveSelectClick() {
      // await this.$confirm.show({
      //   text: this.$t('addUnlimitedAccountPage.addAccountText'),
      //   yesText: this.$t('common.add')
      // })
      try {
        this.$loading.show();
        await mulModifyUnlimited({
          ids: [...this.selectIds, ...this.oldSelectIds],
        });
        this.$router.go(-1);
        this.$toast.show({ message: this.$t("common.success") });
      } catch (e) {
        showErrorMsg(e);
      } finally {
        this.$loading.hide();
      }
    },
    /**
     * 返回按钮点击事件
     */
    backClick() {
      this.$router.go(-1);
    },
    /**
     * add Instagram 点击事件
     */
    addInstagramClick() {
      // this.$router.push({ name: 'LoginInstagramPage' })
    },
  },
  computed: {
    ...mapGetters({
      user: CURRENT_USER_INFO_SIMPLE,
    }),
    /**
     * 计算列表
     * @returns {Array}
     */
    list() {
      // 根据类型进行分组(过滤掉member和已选择的unlimited账号，同时去掉无密码用户)
      let list = [];
      this.user.linkedInstagramList
        .filter((l) => !l.isMember && l.status !== 2 && !l.isUnlimited)
        .forEach((l) => {
          // 根据选中selectids判断该项是否选中
          l.select =
            this.selectIds.find((id) => id === l.id) !== undefined ||
            this.oldSelectIds.find((id) => id === l.id) !== undefined;
          list.push(l);
        });
      return list;
    },
    /** 允许添加的ins数量 */
    allowAddInsNum() {
      const insUserIds = this.selectIds.filter((id) => {
        // 找到选中项
        const select = this.user.linkedInstagramList.find((l) => l.id === id);
        if (select.socialNetwork === 1) {
          return true;
        }
        return false;
      });
      return this.user.premiumInstagramRemaining - insUserIds.length;
    },
    allowAddFbNum() {
      const fbUserIds = this.selectIds.filter((id) => {
        // 找到选中项
        const select = this.user.linkedInstagramList.find((l) => l.id === id);
        if (select.socialNetwork === 2 || select.socialNetwork === 3) {
          return true;
        }
        return false;
      });
      return this.user.premiumFacebookRemaining - fbUserIds.length;
    },
    allowAddTwNum() {
      const twUserIds = this.selectIds.filter((id) => {
        // 找到选中项
        const select = this.user.linkedInstagramList.find((l) => l.id === id);
        if (select.socialNetwork === 4) {
          return true;
        }
        return false;
      });
      return this.user.premiumTwitterPublisherCount - twUserIds.length;
    },
    /**
     * 2018-7-13 计算是否至少有一个选中项
     */
    hasSelectOne() {
      return [...this.selectIds, ...this.oldSelectIds].length > 0;
    },
    /**
     * 2019-8-2 是否存在至少一个fb老用户
     */
    hasFBPremium() {
      return (
        this.user.linkedInstagramList.find(
          (l) => l.wasPremium && l.socialNetwork !== 1
        ) !== undefined
      );
    },
    /**
     * 2019-8-2 是否存在至少一个fb老用户
     */
    hasInsPremium() {
      return (
        this.user.linkedInstagramList.find(
          (l) => l.wasPremium && l.socialNetwork === 1
        ) !== undefined
      );
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // 通过 `vm` 访问组件实例
      if (from.name === "MyPlanPage") {
        vm.selectIds = [];
      }
    });
  },
};



// WEBPACK FOOTER //
// ./src/pages/auto_post_account/AddAutoPost.vue